/* Recensioni a carosello: frecce di scorrimento e rotazione automatica (secondi impostati nel theme editor, 0 = ferma).
   Le recensioni di Google sono già nella pagina: arrivano dal campo del negozio custom.recensioni_google. */
(() => {
  const carosello = (sezione) => {
    const lista = sezione.querySelector('.custom-recensioni__lista');
    const comandi = sezione.querySelector('.custom-recensioni__comandi');
    if (!lista || !comandi) return;
    const [indietro, avanti] = comandi.querySelectorAll('button');
    const passo = () => {
      const prima = lista.querySelector('.custom-recensioni__scheda');
      return prima ? prima.getBoundingClientRect().width + 20 : lista.clientWidth;
    };
    const fine = () => lista.scrollLeft >= lista.scrollWidth - lista.clientWidth - 4;
    const aggiorna = () => {
      const scorribile = lista.scrollWidth - lista.clientWidth > 4;
      comandi.hidden = !scorribile;
      indietro.disabled = lista.scrollLeft <= 4;
      avanti.disabled = fine();
    };
    const vai = (direzione) => lista.scrollBy({ left: direzione * passo(), behavior: 'smooth' });
    indietro.addEventListener('click', () => vai(-1));
    avanti.addEventListener('click', () => vai(1));
    lista.addEventListener('scroll', aggiorna, { passive: true });
    window.addEventListener('resize', aggiorna);
    aggiorna();

    const secondi = Number(sezione.dataset.velocita);
    if (!secondi || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let fermo = false;
    ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach((evento) => sezione.addEventListener(evento, () => (fermo = true), { passive: true }));
    ['mouseleave', 'focusout'].forEach((evento) => sezione.addEventListener(evento, () => (fermo = false)));
    setInterval(() => {
      if (fermo || document.hidden || lista.scrollWidth - lista.clientWidth <= 4) return;
      const rettangolo = lista.getBoundingClientRect();
      if (rettangolo.bottom < 0 || rettangolo.top > window.innerHeight) return;
      if (fine()) lista.scrollTo({ left: 0, behavior: 'smooth' });
      else vai(1);
    }, secondi * 1000);
  };

  const inizia = () =>
    document.querySelectorAll('.custom-recensioni').forEach((sezione) => {
      if (sezione.dataset.pronta) return;
      sezione.dataset.pronta = 'true';
      carosello(sezione);
    });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inizia);
  else inizia();
  document.addEventListener('shopify:section:load', inizia);
})();
